// Copyright (c) 2016 Deere & Company

import PinsNotRegistered from '@deere/cps-it.warranty-model-factory/lib/pins-not-registered';
import t from 'tcomb';

const Report = t.list(PinsNotRegistered, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/pins-not-registered/state/report.js